export enum ChatRole {
  visitor = 'visitor',
  expositor = 'expositor',
}

export enum BotModeEnum {
  app = 'app',
  web = 'web',
}

export enum LanguagesEnum {
  en = 'en',
  it = 'it',
}

export enum WebsocketActionsEnum {
  NEW_MESSAGE = 'new_message',
  STREAM = 'stream',
  END_STREAM = 'end_stream',
  UPDATE_CHAT_PARTICIPANTS = 'update_chat_participants',
}

export type ChatWebSocketMessage = {
  action: WebsocketActionsEnum
  body: any
  messageId: string
}

export type BotMode = BotModeEnum.app | BotModeEnum.web
